import { render, staticRenderFns } from "./LeaveGroup.vue?vue&type=template&id=3af0423c&scoped=true&"
import script from "./LeaveGroup.vue?vue&type=script&lang=js&"
export * from "./LeaveGroup.vue?vue&type=script&lang=js&"
import style0 from "./LeaveGroup.vue?vue&type=style&index=0&id=3af0423c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0423c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af0423c')) {
      api.createRecord('3af0423c', component.options)
    } else {
      api.reload('3af0423c', component.options)
    }
    module.hot.accept("./LeaveGroup.vue?vue&type=template&id=3af0423c&scoped=true&", function () {
      api.rerender('3af0423c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/LeaveGroup.vue"
export default component.exports